import { Text, Placeholder, NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import useHelpers from 'hooks/helpers';
import { useState } from 'react';
import styles from './styles/SectionSelector.module.scss';
import './styles/SectionSelector.module.scss';
import Slider from 'components/Functional/Slider/Slider';
import { SwiperSlide } from 'swiper/react';
import { Navigation, Keyboard } from 'swiper/modules';
import { ComponentProps } from 'lib/component-props';

type ItemsType = {
  displayName: string;
  id: string;
  name: string;
  template: string;
  fields: {
    pictogram: {
      value: string;
    };
    title: {
      value: string;
    };
  };
};

type Props = Partial<ComponentProps> & {
  fields: {
    description: {
      value: string;
    };
    items: Array<ItemsType>;
    subtitle: {
      value: string;
    };
    title: {
      value: string;
    };
  };
  allFundsTabTabs: {
    key: string;
    title: string;
  }[];
};

const SectionSelector = ({ rendering, fields, allFundsTabTabs }: Props): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const [activeTab, setActiveTab] = useState(0);

  const sliderOptions = {
    modules: [Navigation, Keyboard],
    slidesPerView: 'auto' as const,
    spaceBetween: 15,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      768: {
        spaceBetween: 30,
      },
    },
  };

  const toggleTab = (tabIndex: number) => {
    if (tabIndex !== activeTab) {
      setActiveTab(tabIndex);
    } else {
      setActiveTab(-1);
    }
  };
  return (
    <section id={anchorId} className="section-selector w-100 pt-5 pt-md-1 background-white">
      <div className={`container ${styles['section-selector']} pb-3`}>
        {fields.title && <Text tag="h2" className="col-12 col-lg-8" field={fields.title} />}
        {fields.description && (
          <Text tag="p" className="body-default mt-5 col-12 col-lg-8" field={fields.description} />
        )}

        <div className="d-flex align-items-center mt-3 mb-4">
          {fields.subtitle && <Text tag="h4" className="col col-lg-8" field={fields.subtitle} />}
        </div>
        {fields.items.length !== 0 && (
          <Slider className={styles['tabs-wrapper']} sliderOptions={sliderOptions}>
            {fields.items.map((item, index) => (
              <SwiperSlide className={styles['swiper-slide']} key={index}>
                <div
                  className={`${styles.tabs} ${activeTab === index ? styles.active : ''}`}
                  onClick={() => toggleTab(index)}
                >
                  {item.fields.pictogram && (
                    <NextImage
                      field={item.fields.pictogram}
                      width={64}
                      height={64}
                      className={`${styles.image} mb-2`}
                    />
                  )}
                  <Text
                    field={item.fields.title}
                    tag="p"
                    className={`subheader-2 ${styles['subheader-2']}`}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Slider>
        )}
      </div>
      <div>
        {fields.items.length !== 0 &&
          fields.items.map((item, index) => (
            <>
              <div className={styles.placeholder}>
                {activeTab === index && (
                  <Placeholder
                    name={`abrdn-section-selector-tab-${index}`}
                    rendering={rendering}
                    allFundsTabTabs={allFundsTabTabs}
                  />
                )}
              </div>
            </>
          ))}
      </div>
    </section>
  );
};

export default SectionSelector;
